/* eslint-disable no-unused-vars */
import { Menu } from 'antd';
import React from 'react';
import { NavLink, useLocation, useRouteMatch } from 'react-router-dom';
// eslint-disable-next-line import/no-cycle
import Routes from '../../Routes';
import DokanMenuIcons from '../icon/DokanMenuIcons';

const SettingsPageSidebar = () => {
    const { path } = useRouteMatch();
    const location = useLocation();
    const activeClass = 'bg-layout border border-primary rounded-3xl';
    const inactiveClass = 'border-primary text-primary';
    return (
        <>
            <div className="flex flex-row md:flex-col px-3 py-12">
                {Routes.find((menu) =>
                    // eslint-disable-next-line no-prototype-builtins
                    menu.hasOwnProperty('subMenu')
                ).subMenu.map((subMenu) => (
                    <div
                        key={subMenu.id}
                        className={`pl-3 flex items-center ${
                            location.pathname === `/settings${subMenu.path}`
                                ? activeClass
                                : inactiveClass
                        }`}
                    >
                        <DokanMenuIcons icon={subMenu.icon} isSubMenu size={3} />
                        <NavLink exact className="ml-5px p-10px" to={`${path}${subMenu.path}`}>
                            {subMenu.name}
                        </NavLink>
                    </div>
                ))}
            </div>
        </>
    );
};
export default SettingsPageSidebar;
